const replaceConsecutiveSpaces = (text: string): string => {
  return text.replace(/\s\s+/g, " ");
};

const replaceNewLineWithHtmlBreaks = (text: string | undefined): string => {
  return text?.replace(/\n/g, "<br />") ?? "";
};

const stringContainsIgnoreCase = (inputString: string, contains: string) => {
  const isContains =
    inputString.toLowerCase().indexOf(contains.toLowerCase()) !== -1;
  return isContains;
};

const stringHelper = {
  replaceConsecutiveSpaces,
  replaceNewLineWithHtmlBreaks,
  stringContainsIgnoreCase,
};

export default stringHelper;
